module.exports = __webpack_public_path__ + "img/流体力学1_3_1.43652cee.jpg";